interface Props {
  children: React.ReactNode;
}

export const ConfigEditorProviders = ({ children }: Props) => {
  return <div>{children}</div>;
};
